import { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import axiosApi from "../../core/interceptor/interceptor";
import { config } from "../../config";
import { sideMenuItems } from "../../Util/helper";

const fetchAllowedRoute = async () => {
    try {
        const response = await axiosApi.get(`${config.apiUrl}/permissions`);
        if (response?.data?.data?.length) {
            const slugs = response.data.data.map(x => x.acl_permission?.slug);
            const route = sideMenuItems.find(x => slugs.includes(x.slug));
            if (route) {
                if (route.childs?.length) {
                    return `admin/${route.childs[0].type === "event-page" ? "events" : route.route}/${route.childs[0].url}`;
                }
                return `admin/${route.route}`;
            }
        }
        return '/admin/users';
    } catch (error) {
        console.error("Error while getting user permissions for redirect:", error);
        return '/admin/users';
    }
};

const AdminRedirect = () => {
    const history = useHistory();
    useEffect(() => {
        const redirect = async () => {
            if (!localStorage.getItem('token')) {
                history.push('/login');
            } else {
                const path = await fetchAllowedRoute();
                const cleanPath = (path.endsWith('/') ? path.slice(0, -1) : path).replace('//', '/');
                history.push(cleanPath);
            }
        };
        redirect();
    }, []);

    return null;
};

export default AdminRedirect;
